const MACHINE_EDIT_ROLES = new Set([
  "admin",
  "manager",
  "maintenance_manager",
]);

const MACHINE_ARCHIVE_ROLES = new Set([
  "admin",
  "manager",
  "maintenance_manager",
]);

const MACHINE_METER_ROLES = new Set([
  "admin",
  "manager",
  "maintenance_manager",
  "technician",
]);

function effectiveRole(user) {
  return user?.actualRole || user?.role || "";
}

export function canEditMachine(user) {
  return MACHINE_EDIT_ROLES.has(effectiveRole(user));
}

export function canArchiveMachine(user) {
  return MACHINE_ARCHIVE_ROLES.has(effectiveRole(user));
}

export function canUpdateMachineMeter(user) {
  return MACHINE_METER_ROLES.has(effectiveRole(user));
}
